import { createModel, RematchDispatch } from '@rematch/core';
import { RootModel } from '../../models';

export const storeName = 'mediaModal';

const initialValues = {
  visible: false,
};

export const mediaModal: any = createModel<RootModel>()({
  state: initialValues, // initial state
  reducers: {
    setVisible(state, payload) {
      return {
        ...state,
        visible: payload,
      };
    },
  },
  effects: (dispatch: RematchDispatch<typeof mediaModal>) => ({}),
});
export default mediaModal;
